<app-calendar-appointments-wrapper
  [patient]="this.patient"
  [treatments]="this.treatments"
  [quickMode]="true"
></app-calendar-appointments-wrapper>
